import { InjectionToken } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';

export type LcsDateTimeFormats = Pick<MatDateFormats, 'parse'> &
   Pick<MatDateFormats, 'display'> & {
      parse: { dateTimeInput: any };
      display: { dateTimeInput: any; hours: any; minutes: any; timeA11yLabel: any };
   };

export const LCS_DATE_TIME_FORMATS = new InjectionToken<LcsDateTimeFormats>('lcs-date-time-formats');
